export default __webpack_public_path__ + "static/media/thumbnail.357ba109.png";